import { createClient } from "@supabase/supabase-js";

const supabase = createClient("https://qlewrjcbsyypecovgduy.supabase.co", "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InFsZXdyamNic3l5cGVjb3ZnZHV5Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3MTMxOTIyNTcsImV4cCI6MjAyODc2ODI1N30.roZmVGylQaTV7hl-8MEeoxnGoajhfF0chQ4tM8VAvqc");

export default supabase;